import React, { useContext } from "react";
import "./Footer.css";
import { ThemeContext } from "../../contexts/ThemeContext";
import Typewriter from "typewriter-effect";

function Footer() {
  const { theme } = useContext(ThemeContext);

  return (
    <div className="footer" style={{ backgroundColor: theme.secondary }}>
      <h3 id="madebysangam">Made with ❤️ By Sangam</h3>
    </div>
  );
}

export default Footer;
